export default __webpack_public_path__ + "static/media/heineken.4b56dcce.png";